import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/salesContent';
export function BonusSection() {
  return <section className="bg-mist py-16 lg:py-24" data-id="element-11" data-mp="1ofc49qi2clfd">
      <div className="mx-auto max-w-6xl px-5" data-id="element-12" data-mp="22fd555ybvsuu">
        <h2 className="mx-auto max-w-3xl text-center font-display text-3xl font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-13" data-mp="22f3fjjh73npo">
          Get These 5 Bonus PDFs <span className="text-aqua" data-id="element-14" data-mp="1ao7ah51dmncy">FREE</span> with Your Guide
        </h2>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-5" data-id="element-15" data-mp="1am2xlxli2e0j">
          {bonuses.map((bonus, i) => <li key={bonus.title} className="grid grid-cols-[96px_1fr] items-start gap-4 rounded-2xl bg-white p-4 sm:grid-cols-1" data-id="element-16" data-mp="1jgir5z6ouwfq" data-mpi={i}>
              <div className="relative overflow-hidden rounded-xl bg-mist" data-id="element-17" data-mp="1eny035f62xfw">
                <img src={bonus.cover} alt={`${bonus.title} cover`} className="aspect-square w-full object-cover" data-id="element-18" data-mp="qywzu5ghmslp" />
                <span className="absolute left-2 top-2 rounded-md bg-navy px-2 py-1 font-display text-[10px] font-extrabold uppercase tracking-wider text-white" data-id="element-19" data-mp="29rbh0wkl17ym">
                  Bonus {i + 1}
                </span>
              </div>
              <div data-id="element-20" data-mp="2jjz9xg8fyrs2">
                <h3 className="font-display text-base font-extrabold uppercase leading-snug text-navy lg:min-h-[4.2rem]" data-id="element-21" data-mp="2ogpry93t3xg4">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-ink" data-id="element-22" data-mp="1qvbonknp02ei">{bonus.text}</p>
              </div>
            </li>)}
        </ul>

        <p className="mt-10 flex items-center justify-center gap-2 text-center font-display text-lg font-bold text-navy" data-id="element-23" data-mp="20r571ko3eq47">
          <GiftIcon className="h-5 w-5 text-aqua" aria-hidden="true" data-id="element-24" data-mp="25r9d0grdk2g6" />
          All 5 Bonus PDFs Included at No Extra Cost.
        </p>
      </div>
    </section>;
}